import React from "react";

// Styles
import Styles from "./TransporterCard.module.scss";

// Components
import BaseCard from "@vahak/core/dist/components/cards/base-card/BaseCard";
import TransporterCardTopSection from "../transporter-card-top-section/TransporterCardTopSection";
import TransporterCardBottomSection from "../transporter-card-bottom-section/TransporterCardBottomSection";

// Types
import { TransporterCard as TransporterCardTypes } from "@vahak/core/dist/custom-types/cards";

const TransporterCard = ({
    companyName,
    jobTitle,
    totalConnections,
    totalViews,
    companyRunningFrom,
    companyLocation,
    isGstVerified,
    isAadharVerified,
    companyId,
    logo,
    ratings,
    onGetContactDetailsCtaClick,
    onViewProfileCtaClick,
    companyPhoneNumber,
    agentDetails
}: TransporterCardTypes) => {
    return (
        <div className={Styles.cardWrapper}>
            <BaseCard
                topSection={
                    <TransporterCardTopSection
                        companyName={companyName}
                        logo={logo}
                        jobTitle={jobTitle}
                        totalConnections={totalConnections}
                        totalViews={totalViews}
                        companyRunningFrom={companyRunningFrom}
                        companyLocation={companyLocation}
                        isGstVerified={isGstVerified}
                        isAadharVerified={isAadharVerified}
                        companyId={companyId}
                        ratings={ratings}
                        agentDetails={agentDetails}
                    />
                }
                bottomSection={
                    <TransporterCardBottomSection
                        companyId={companyId}
                        companyName={companyName}
                        companyLocation={companyLocation}
                        onGetContactDetailsCtaClick={onGetContactDetailsCtaClick}
                        onViewProfileCtaClick={onViewProfileCtaClick}
                        companyPhoneNumber={companyPhoneNumber}
                    />
                }
            />
        </div>
    );
};

export default TransporterCard;
